import { z } from 'zod';

export enum AiStatus {
  Success = 'success',
  Pending = 'pending',
  Error = 'error',
  Cancelled = 'cancelled',
}
export const aiStatusSchema = z.enum([
  AiStatus.Success,
  AiStatus.Pending,
  AiStatus.Error,
  AiStatus.Cancelled,
]);

export enum AiProvider {
  OpenAi = 'openai',
  Claude = 'claude',
  Gemini = 'gemini',
  Perplexity = 'perplexity',
}
